/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-24 19:24:34
 */
import {Button, Divider, Layout} from "antd";
import AvatarIcon from "./components/AvatarIcon";
import {useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import Language from "./components/Language";

import "./index.less";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";

const LayoutHeader = () => {
	const {Header} = Layout;

	const {t} = useTranslation();
	const {currentUser, currentTeam} = useSelector(state => state.global);
	const [isOwner, setIsOwner] = useState(false);

	useEffect(() => {
		setIsOwner(currentUser?.id === currentTeam?.ownerId);
	}, [currentUser, currentTeam]);

	return (
		<Header style={{height: "64px", paddingLeft: "24px", paddingRight: "24px"}}>
			<div className="header-lf">
				<Language/>
			</div>
			<div className="header-ri">
				{isOwner &&
					<Link to={"/billing/plan"}>
						<Button style={{borderRadius: 6, color: "#fff", background: "#565BDD"}}>
							{t("nav.upgrade.button")}
						</Button>
					</Link>
				}
				<Divider type="vertical" style={{marginLeft: "20px", marginRight: "20px"}}/>
				<AvatarIcon/>
			</div>
		</Header>
	);
};

export default LayoutHeader;
